import cidrRegex from 'cidr-regex';
import { z } from 'zod';
import {
  DEFAULT_NETMASK_REQUIRED_v4_REMOTE_ERR,
  DEFAULT_NETMASK_REQUIRED_v6_REMOTE_ERR,
  EMPTY_ERR,
  filterIpV4,
  filterIpV6,
  validAllowDeny,
} from './helpers/allow-list.ts';

const remoteAllowRuleSchema = z.object({
  allow: z.boolean(),
  cidr: z.string({ required_error: EMPTY_ERR }).regex(cidrRegex({ exact: true })), // the real validation happens outside of zod
});

// Aligns with the actual ConfigOverride type: {[cidr: string]: boolean}
export const remoteAllowRuleOverrideSchema = z.record(z.string().regex(cidrRegex({ exact: true })), z.boolean());

// Note: this is used for the host page, but not tag config
export const remoteAllowListSchema = z
  .array(remoteAllowRuleSchema)
  .refine((values) => validAllowDeny(filterIpV4(values)), DEFAULT_NETMASK_REQUIRED_v4_REMOTE_ERR)
  .refine((values) => validAllowDeny(filterIpV6(values)), DEFAULT_NETMASK_REQUIRED_v6_REMOTE_ERR);
